// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container{height:100%}.error-center{padding-top:10%;position:relative}", "",{"version":3,"sources":["webpack://./src/pages/error/styles.scss"],"names":[],"mappings":"AAAA,WACE,WAAA,CAGF,cACE,eAAA,CACA,iBAAA","sourcesContent":[".container {\n  height: 100%;\n}\n\n.error-center {\n  padding-top: 10%;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
